<script setup lang="ts">
import { UiIcon, UiIconButton, UiTag, UiText, UiTooltip } from "@shopexperts/shared";

const props = defineProps<{
  label: string;
  overridden: boolean;
  scrapedValue: string;
  tooltip?: string;
}>();

const emit = defineEmits<{
  (e: "reset"): void;
}>();
</script>

<template>
  <div class="min-w-0" :class="props.overridden ? 'rounded-md bg-amber-50 p-2 ring-1 ring-amber-300' : ''">
    <div class="mb-1 flex items-center gap-1">
      <UiText as="span" variant="caption-normal" class="text-se-gray-500" :text="props.label" />
      <UiTooltip v-if="props.tooltip" :content="props.tooltip">
        <UiIcon name="info-circle" class="h-3.5 w-3.5 text-se-gray-400" />
      </UiTooltip>
      <template v-if="props.overridden">
        <UiTag text="Mapped" variant="rounded" narrow />
        <UiTooltip content="Reset to the scraped value">
          <UiIconButton icon="close" :aria-label="`Reset ${props.label} to the scraped value`" @click="emit('reset')" />
        </UiTooltip>
      </template>
    </div>
    <slot />
    <UiText v-if="props.overridden" as="p" variant="caption-normal" class="mt-1 break-words text-se-gray-600" :text="`Scraped: ${props.scrapedValue}`" />
  </div>
</template>
